module.exports = __webpack_public_path__ + "assets/cynergy-logo-black.b53219a3.svg";